/*
 * Copyright (c) 2022 Puratos. All rights reserved.
 */

import moment from "moment/min/moment-with-locales.min"
import {getCookie} from "./roleUtils";


export function getMoment() {
    const languageCookie = getCookie('ll');
    const bodyLanguage = document.body.getAttribute("data-language");

    if (languageCookie) {
        moment.locale(bodyLanguage || languageCookie);
    }

    return moment;
}
